import { render, staticRenderFns } from "./SampleShelfRenderer.vue?vue&type=template&id=76f50c9a&"
import script from "./SampleShelfRenderer.vue?vue&type=script&lang=js&"
export * from "./SampleShelfRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports